import * as React from "react"

/**
 *  A hook to copy text to the clipboard.
 * @param timeout - The time in milliseconds to show the copied state
 * @param callback - A callback function to run after the text is copied
 */
export function useClipboard({
  timeout,
  callback,
}: {
  timeout: number
  callback?: (copiedValue: string) => void
}) {
  const [copied, setCopied] = React.useState<boolean>(false)

  const copy = React.useCallback(async (text: string) => {
    if (!navigator?.clipboard) {
      console.warn("Clipboard not supported")
      return false
    }
    try {
      await navigator.clipboard.writeText(text)
      setTimeout(() => setCopied(false), timeout)
      setCopied(true)
      callback?.(text)
      return true
    } catch (error) {
      console.warn("Copy failed", error)
      setCopied(false)
      return false
    }
  }, [])

  return { copy, copied }
}
